import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateRfqPopInput,
    ModelSortDirection,
    RfqPop,
    UpdateRfqPopInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class RfqPopService {
    private amplifyClient = generateClient();

    constructor() {}

    async getRfqPop(id: string): Promise<RfqPop | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getRfqPop,
                    variables: { id }
                })
            ).data.getRfqPop;
            return data ? (data as RfqPop) : null;
        } catch (error) {
            console.error('Error finding RfqPop:', error);
            return null;
        }
    }

    async listAllRfqsPopByCreated(
        estatus: string,
        sortDirection: ModelSortDirection = ModelSortDirection.DESC,
        pageLimit: number = 20
    ): Promise<RfqPop[]> {
        const rfqs: RfqPop[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listRfqsPopByCreated,
                        variables: {
                            estatus,
                            limit: pageLimit,
                            nextToken,
                            sortDirection
                        }
                    })
                ).data.listRfqsPopByCreated;

                if (response?.items) {
                    rfqs.push(...(response.items as RfqPop[]));
                }
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return rfqs;
        } catch (error) {
            console.error('Error listing RfqPop:', error);
            return [];
        }
    }

    async listRfqPops(): Promise<RfqPop[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfqPops
                })
            ).data.listRfqPops.items;
            if (data) return data as RfqPop[];
        } catch (error) {
            console.error('Error finding RfqPop:', error);
            return null;
        }
    }

    async listRfqsPopByCreated(estatus: string): Promise<RfqPop[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfqsPopByCreated,
                    variables: {
                        estatus
                    }
                })
            ).data.listRfqsPopByCreated.items;
            if (data) return data as RfqPop[];
        } catch (error) {
            console.error('Error finding RfqPop:', error);
            return null;
        }
    }

    async listPopRfqsByClient(estatus: string): Promise<RfqPop[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ListPopRfqsByClient,
                    variables: {
                        estatus
                    }
                })
            ).data.ListPopRfqsByClient.items;
            if (data) return data as RfqPop[];
        } catch (error) {
            console.error('Error finding RfqPop:', error);
            return null;
        }
    }

    async listRfqsPopByCreator(estatus: string): Promise<RfqPop[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ListRfqsPopByCreator,
                    variables: {
                        estatus
                    }
                })
            ).data.ListRfqsPopByCreator.items;
            if (data) return data as RfqPop[];
        } catch (error) {
            console.error('Error finding RfqPop:', error);
            return null;
        }
    }

    async createRfqPop(input: CreateRfqPopInput): Promise<RfqPop> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createRfqPop,
                    variables: {
                        input
                    }
                })
            ).data.createRfqPop;
            if (date) return date as RfqPop;
        } catch (error) {
            console.error('Error creating RfqPop:', error);
            return null;
        }
    }

    async updateRfqPop(input: UpdateRfqPopInput): Promise<RfqPop> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateRfqPop,
                    variables: {
                        input
                    }
                })
            ).data.updateRfqPop;
            if (date) return date as RfqPop;
        } catch (error) {
            console.error('Error update RfqPop:', error);
            return null;
        }
    }
}
